// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "ff398bacfbc9601e97ed" + ".bundle.js";
};